import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import CreateOrder from '../BillingOrder/CreateOrder';
import PendingList from './PendingList';
import AcceptedOrder from './AcceptedOrder';
import LabCancelledOrder from './LabCancelledOrder';
import LabCreateOrder from './LabCreateOrder';

export default function LabOrderIndex() {
    const [value, setValue] = useState(0);

    return (
        <Box width="100%">
            <Tabs value={value} onChange={(e, newValue) => setValue(newValue)}>
                <Tab sx={{ textTransform: 'capitalize', minHeight: '1vw', fontWeight: 600 }} label="Create Order" />
                <Tab sx={{ textTransform: 'capitalize', minHeight: '1vw', fontWeight: 600 }} label="Pending List" />
                <Tab sx={{ textTransform: 'capitalize', minHeight: '1vw', fontWeight: 600 }} label="Accepted Order" />
                <Tab sx={{ textTransform: 'capitalize', minHeight: '1vw', fontWeight: 600 }} label="Cancelled Order" />
            </Tabs>
            <Box sx={{ width: "99%" }}>
                {value === 0 && <LabCreateOrder />}
                {value === 1 && <PendingList />}
                {value === 2 && <AcceptedOrder />}
                {value === 3 && <LabCancelledOrder />}
            </Box>
        </Box>
    );
}
